import {manageModal} from '@js/modules/modal';

import {userStore} from '@js/stores/userStore';
import {requireAccount} from '@js/actions/accountActions';


// Wire server-rendered account-gated triggers ([data-account-gate]) to the account
// modal. Only present for visitors (locked links render server-side when logged out),
// so this runs inside the guest-only init. On connect, resume the pending download.
function _wireAccountGateTriggers() {
    document.querySelectorAll('[data-account-gate]').forEach((element) => {
        element.addEventListener('click', (event) => {
            event.preventDefault();

            const feature = element.getAttribute('data-account-gate');
            const href = element.getAttribute('data-account-href');
            const blank = element.getAttribute('data-account-blank');

            requireAccount(feature, () => {
                if (!href) {
                    return;
                }

                if (blank) {
                    window.open(href, '_blank');
                } else {
                    window.location.href = href;
                }
            });
        });
    });
}


export function initializeConnection() {
    const isUserConnected = !!window.currentUserId;

    userStore.isConnected = isUserConnected;

    if (isUserConnected) {
        return;
    }

    const SignupForm = () => import('@js/components/layouts/signup');
    const LoginForm = () => import('@js/components/layouts/login');
    const AccountModalForm = () => import('@js/components/layouts/accountModal');

    const signupModal = manageModal('signup-modal', SignupForm, {
        preloadTime: 1500
    });
    const loginModal = manageModal('login-modal', LoginForm, {
        preloadTime: 1500
    });
    // Unified "create a free account" modal, gating account-required features. Guest-only
    // (this whole init returns early for connected users), code-split + preloaded.
    const accountModal = manageModal('account-modal', AccountModalForm, {
        preloadTime: 1500
    });

    userStore.signupModal = signupModal;
    userStore.loginModal = loginModal;
    userStore.accountModal = accountModal;

    _wireAccountGateTriggers();
}
